import React, { useState, useEffect } from "react";
import ReactSVG from "react-svg";
import PropTypes from "prop-types";

import { KEY_CODES } from "./helpers";

const CustomInput = props => {
    const { onChange, onChangeRaw, onClick, isClearable, value, rawValueError, ...restProps } = props;

    const [localValue, setLocalValue] = useState("");

    const parsedValue = value !== rawValueError ? value : "";

    const handleChange = ev => {
        const { value } = ev.target;
        setLocalValue(value);
        onChangeRaw(value);
    };

    const handleOpenCalendar = () => onClick();

    const getIcons = () => {
        return (
            <ReactSVG
                tabIndex="0"
                className="calendar-icon"
                src={`/data/svg/calendar.svg`}
                onClick={handleOpenCalendar}
            />
        );
    };

    useEffect(() => {
        if (value && value !== rawValueError) {
            setLocalValue("");
        }
    }, [value]);

    return (
        <div className="datepicker-field-wrap">
            <input
                type="text"
                {...restProps}
                value={localValue || parsedValue}
                onBlur={e => props.input && props.input.onBlur(undefined)}
                onChange={handleChange}
            />
            {getIcons()}
        </div>
    );
};

CustomInput.propTypes = {};
CustomInput.defaultProps = {};

export default CustomInput;
